



// 



import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChildren, AfterViewInit, QueryList, ElementRef, OnChanges } from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { AlertService, AlertDialog, DialogType, AlertMessage, MessageSeverity } from '../services/alert.service';
import { NotificationService } from "../services/notification.service";
import { AppTranslationService } from "../services/app-translation.service";
import { AccountService } from '../services/account.service';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { AppTitleService } from '../services/app-title.service';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';
import { Permission } from '../models/permission.model';
import { LoginComponent } from "../components/login/login.component";
import { SnotifyService } from "ng-snotify";


var alertify: any = require('../assets/scripts/alertify.js');


@Component({
    selector: "quick-app",
    template: require('./app.component.html'),
    styles: [require('./app.component.css'), require('../styles.css'), require('../themes.css')],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewInit, OnChanges {

    isAppLoaded: boolean;
    isUserLoggedIn: boolean;
    shouldShowLoginModal: boolean;
    removePrebootScreen: boolean;
    newNotificationCount = 0;
    appTitle = "Benefits Admin";
    appLogo = require("../assets/images/logo.png");

    stickyToasties: number[] = [];

    dataLoadingConsecutiveFailurs = 0;
    notificationsLoadingSubscription: any;

    @ViewChildren('loginModal,loginControl')
    modalLoginControls: QueryList<any>;

    loginModal: ModalDirective;
    loginControl: LoginComponent;

    isCanViewCaseDashboard: boolean = false

    get notificationsTitle() {

        let gT = (key: string) => this.translationService.getTranslation(key);

        if (this.newNotificationCount)
            return `${gT("app.Notifications")} (${this.newNotificationCount} ${gT("app.New")})`;
        else
            return gT("app.Notifications");
    }


    constructor(storageManager: LocalStoreManager, 
        private accountService: AccountService,
        private alertService: AlertService,
        private snotifyService: SnotifyService,
        private notificationService: NotificationService, private appTitleService: AppTitleService,
        private authService: AuthService, private translationService: AppTranslationService, public configurations: ConfigurationService, public router: Router) {

        storageManager.initialiseStorageSyncListener();

        //translationService.addLanguages(["en", "fr", "de", "pt", "ar", "ko"]);
        //translationService.setDefaultLanguage('en');


        //this.appTitleService.appName = this.appTitle;
        //console.log(this.authService.currentUser.roles);

        router.events.subscribe(val => {
            if (val instanceof NavigationEnd) {
    
                if (this.authService.currentUser) {
                    this.authService.currentUser.roles.forEach(r => {
                        if (r == 'Full' || r == 'FullView') {
                            this.isCanViewCaseDashboard = true;
                            return;
                        }
                    })
                }
            }
        })
    }


    ngAfterViewInit() {

        this.modalLoginControls.changes.subscribe((controls: QueryList<any>) => {
            controls.forEach(control => {
                if (control) {
                    if (control instanceof LoginComponent) {
                        this.loginControl = control;
                        this.loginControl.modalClosedCallback = () => this.loginModal.hide();
                    }
                    else {
                        this.loginModal = control;
                        this.loginModal.show();
                    }
                }
            });
        });
    }


    onLoginModalShown() {
        this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again", MessageSeverity.info);
    }


    onLoginModalHidden() {
        this.alertService.resetStickyMessage();
        this.loginControl.reset();
        this.shouldShowLoginModal = false;

        if (this.authService.isSessionExpired)
            this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again to renew your session", MessageSeverity.warn);
    }


    onLoginModalHide() {
        this.alertService.resetStickyMessage();
    }

    ngOnChanges() {
      
    }

    ngOnInit() {
        
        this.isUserLoggedIn = this.authService.isLoggedIn;

        // 1 sec to ensure all the effort to get the css animation working is appreciated :|, Preboot screen is removed .5 sec later
        setTimeout(() => this.isAppLoaded = true, 1000);
        setTimeout(() => this.removePrebootScreen = true, 1500);

        setTimeout(() => {
            if (this.isUserLoggedIn) {
                this.alertService.resetStickyMessage();

                //if (!this.authService.isSessionExpired)
                this.snotifyService.info("Login", `Welcome back ${this.userName}!`);
                //else
                //    this.alertService.showStickyMessage("Session Expired", "Your Session has expired. Please log in again", MessageSeverity.warn);
            }
        }, 2000);


        this.alertService.getDialogEvent().subscribe(alert => this.showDialog(alert));
        this.alertService.getMessageEvent().subscribe(message => this.showToast(message, false));
        this.alertService.getStickyMessageEvent().subscribe(message => this.showToast(message, true));

        this.authService.reLoginDelegate = () => this.shouldShowLoginModal = true;

        this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
            this.isUserLoggedIn = isLoggedIn;


            if (this.isUserLoggedIn) {
                this.initNotificationsLoading();
            }
            else {
                this.unsubscribeNotifications();
            }

            setTimeout(() => {
                if (!this.isUserLoggedIn) {
                    this.alertService.showMessage("Session Ended!", "", MessageSeverity.default);
                }
            }, 500);
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                let url = (<NavigationStart>event).url;

                if (url !== url.toLowerCase()) {
                    this.router.navigateByUrl((<NavigationStart>event).url.toLowerCase());
                }
            }
        });

      

    }


    ngOnDestroy() {
        this.unsubscribeNotifications();
    }


    private unsubscribeNotifications() {
        if (this.notificationsLoadingSubscription)
            this.notificationsLoadingSubscription.unsubscribe();
    }



    initNotificationsLoading() {

        this.notificationsLoadingSubscription = this.notificationService.getNewNotificationsPeriodically()
            .subscribe((notifications:any) => {
                this.dataLoadingConsecutiveFailurs = 0;
                this.newNotificationCount = notifications.filter(n => !n.isRead).length;
            },
            error => {
                this.alertService.logError(error);

                if (this.dataLoadingConsecutiveFailurs++ < 20)
                    setTimeout(() => this.initNotificationsLoading(), 5000);
                else
                    this.alertService.showStickyMessage("Load Error", "Loading new notifications from the server failed!", MessageSeverity.error);
            });
    }


    markNotificationsAsRead() {

        let recentNotifications = this.notificationService.recentNotifications;

        if (recentNotifications.length) {
            this.notificationService.readUnreadNotification(recentNotifications.map(n => n.id), true)
                .subscribe(response => {
                    for (let n of recentNotifications) {
                        n.isRead = true;
                    }

                    this.newNotificationCount = recentNotifications.filter(n => !n.isRead).length;
                },
                error => {
                    this.alertService.logError(error);
                    this.alertService.showMessage("Notification Error", "Marking read notifications failed", MessageSeverity.error);

                });
        }
    }



    showDialog(dialog: AlertDialog) {

        alertify.set({
            labels: {
                ok: dialog.okLabel || "OK",
                cancel: dialog.cancelLabel || "Cancel"
            }
        });

        switch (dialog.type) {
            case DialogType.alert:
                alertify.alert(dialog.message);

                break
            case DialogType.confirm:
                alertify
                    .confirm(dialog.message, (e) => {
                        if (e) {
                            dialog.okCallback();
                        }
                        else {
                            if (dialog.cancelCallback)
                                dialog.cancelCallback();
                        }
                    });

                break;
            case DialogType.prompt:
                alertify
                    .prompt(dialog.message, (e, val) => {
                        if (e) {
                            dialog.okCallback(val);
                        }
                        else {
                            if (dialog.cancelCallback)
                                dialog.cancelCallback();
                        }
                    }, dialog.defaultValue);

                break;
        }
    }





    showToast(message: AlertMessage, isSticky: boolean) {
        if (message == null) {
            for (let id of this.stickyToasties)
                this.snotifyService.remove(id);
            this.stickyToasties = [];
            return;
        }

        const config = { timeout: isSticky ? 0 : 4000 };
        const title = message.summary || undefined;
        let toast;

        switch (message.severity) {
            case MessageSeverity.success: toast = this.snotifyService.success(message.detail, title, config); break;
            case MessageSeverity.error: toast = this.snotifyService.error(message.detail, title, config); break;
            case MessageSeverity.warn: toast = this.snotifyService.warning(message.detail, title, config); break;
            case MessageSeverity.info:
            case MessageSeverity.wait: toast = this.snotifyService.info(message.detail, title, config); break;
            default: toast = this.snotifyService.simple(message.detail, title, config); break;
        }

        if (isSticky)
            this.stickyToasties.push(toast.id);
    }






    logout() {
        this.authService.logout();
        this.authService.redirectLogoutUser();
    }


    getYear() {
        return new Date().getUTCFullYear();
    }


    get userName(): string {
        return this.authService.currentUser ? this.authService.currentUser.userName : "";
    }


    get fullName(): string {
        return this.authService.currentUser ? this.authService.currentUser.fullName : "";
    }

    get canViewGroups() {
        return this.accountService.userHasPermission(Permission.readGroupsPermission);
    }

    get canViewBenefits() {
        return this.accountService.userHasPermission(Permission.readBenefitsPermission); //eg. viewCustomersPermission
    }

    get canViewPlans() {
        return this.accountService.userHasPermission(Permission.readPlansPermission); //eg. viewProductsPermission
    }

    get canViewVendors() {
        return this.accountService.userHasPermission(Permission.readVendorsPermission);
    }

    get canViewAllMembers() {
        return true;
        //return this.authService.currentUser.roles.indexOf('administrator') > -1;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/app.component.ts